import { getProductTailored } from '@libs/api-proxy-client';
import type { CustomAddress, DeliveryMethodType, TailoredApiData, TailoredApiResponse } from '@libs/common-types';
import { logger } from '@libs/core';

type FetchMiniPdpProductTailored = {
    deliveryMethodsList: DeliveryMethodType[];
    storeId?: string;
    customAddress?: CustomAddress;
    variantSkus: string[];
};

export const fetchMiniPdpProductTailored = async ({
    deliveryMethodsList,
    storeId,
    customAddress,
    variantSkus = [],
}: FetchMiniPdpProductTailored): Promise<TailoredApiData> => {
    try {
        const result = await getProductTailored<TailoredApiResponse>({
            storeId,
            customAddress,
            deliveryMethodsToRetrieve: deliveryMethodsList,
            variantSkus,
        });

        return result.data;
    } catch (error) {
        logger.error('[MINI PDP FETCH TAILORED][Error]: %o', error);
        throw error;
    }
};
